export const PIN_SENT = 'PIN_SENT'
export const RECOVER_FINISHED = 'RECOVER_FINISHED'
export const RECEIVED_COUNTRY_PREFIXES = 'RECEIVED_COUNTRY_PREFIXES'
export const SET_REDIRECT_URI = 'SET_REDIRECT_URI'
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const UPDATE_HAS_TEMP_PASSWORD = 'UPDATE_HAS_TEMP_PASSWORD'
export const SET_2FA_VALIDATION_SESSION = 'SET_2FA_VALIDATION_SESSION'
export const SET_2FA_PROXY = 'SET_2FA_PROXY'
export const FETCH_API_NONCE_REQUEST = 'FETCH_API_NONCE_REQUEST'
export const FETCH_API_NONCE_SUCCESS = 'FETCH_API_NONCE_SUCCESS'
export const FETCH_API_NONCE_FAILURE = 'FETCH_API_NONCE_FAILURE'
